import { StyleObject } from 'styletron-react';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { tabHighlightStyles, tabBorderStyles, tabRootStyles, isPresetTabsSize, tabsSizes, tabListStyles } from './styles';
import * as meta from '../../meta-data.json';
import { TItem, TSize } from './types';

export const overrides = (props: any, orientation: any) => {
	const {
		headerColor,
		initTab,
		items,
		renderAll,
		activateOnFocus,
		activeKey,
		$isFocusVisible,
		isFocusVisible,
		reverse,
		noUnderline,
		fitTabs,
		size,
		arrows,
		...rest
	} = props;
	return {
		Root: {
			style: () => {
				return {
					...tabRootStyles(!!reverse, orientation, size),
				} as StyleObject;
			},
			props: {
				...rest,
				...getBaseCustomProps(props),
				/* 'data-epo': `epo-tabs-${meta.version}`,
				part: `epo-tabs-${meta.version}`, */
			},
		},
		TabBorder: {
			style: tabBorderStyles(props),
		},
		TabHighlight: {
			style: () => {
				return {
					...tabHighlightStyles(props),
				} as StyleObject;
			},
		},
		TabList: {
			style: () => {
				return {
					...tabListStyles(props),
				};
			},
		},
	};
};

export const customTabOverrides = (item: TItem, size: TSize, headerColor: any) => {
	const TabPanelComponentOverride = item.content ? {} : { component: () => null };
	const selectedSize = size && isPresetTabsSize(size) ? tabsSizes[size] : {};

	return {
		TabPanel: {
			...TabPanelComponentOverride,
		},
		ArtworkContainer: {
			style: { marginRight: '2px' },
		},
		Tab: {
			style: ({ $isActive, ...lalala }: any) => {
				return {
					...selectedSize,
					flexShrink: '0',
					backgroundColor: $isActive && headerColor ? 'var(--epods--color-bg) !important' : 'var(--epods--color-bg-transparent)',
					color: 'var(--epods--color-text-tab)',
					fontFamily: 'var(--epods--font-base-semibold)',
					paddingTop: 'var(--epods--tab-padding-y)',
					paddingBottom: 'var(--epods--tab-padding-y)',
					paddingLeft: 'var(--epods--tab-padding-x)',
					paddingRight: 'var(--epods--tab-padding-x)',
					borderRadius: '0',
				};
			},
		},
	};
};
